import React, { useContext } from 'react';
import { Layout } from 'antd';
import { SelectedWebsiteContext } from '../../trackedWebsites/ContextWrapper';
import TrackedWebsites from '../../trackedWebsites/TrackedWebsites';
import Sitemap from '../Sitemap';

const { Content } = Layout;

export default function SitemapGeneratorPage() {
    const { selectedWebsite } = useContext(SelectedWebsiteContext);

    return (
        <Content className="general-layout-content">
            <TrackedWebsites
                tabContent={<Sitemap selectedWebsite={selectedWebsite!} />}
                showDomains
                destroyInactiveTabs={true}
            />
        </Content>
    );
}
